import { Alert, Snackbar } from "@mui/material";
import styles from "../Cadastro.module.css";
import { useEffect, useState } from "react";
import { useForm, useFormContext } from "react-hook-form";
import UploadInput from "../../../../components/Inputs/UploadInput";
import servSolicitacaoFiscalizacaoDocs from "../../../../services/login/servSolicitacaoFiscalizacaoDocs";

import { downloadConteudoBase64 } from "../../../../infra/utils/DownloadFile";

const Documentos = ({
    codigoSolicFiscalizacao,
    documentos,
    setIsLoading,
    setOpenError,
    setErrorMessage,
    situacaoSolic }) => {
    const { register } = useForm();
    const { getValues } = useFormContext();
    const [severity, setSeverity] = useState("info");
    const [openUpload, setOpenUpload] = useState(false);
    const [uploadMessage, setUploadMessage] = useState("");
    const [documentosObrigatorios, setDocumentosObrigatorios] = useState([]);

    const editavel =
        situacaoSolic === 0 || situacaoSolic === 2
            ? true
            : false;

    useEffect(() => {
        const handleDocumentos = () => {
            if (!documentos) return;

            documentos.map((doc) => {
                if (!doc.DefinirExtensoesValidas || doc.ExtensoesValidas.trim() === '') {
                    doc.ExtensoesValidas = '*';
                }
            });

            setDocumentosObrigatorios(documentos);
        };

        handleDocumentos()
    }, [documentos])

    const handleCloseInfo = (event, reason) => {
        if (reason === 'clickaway') return;

        setOpenUpload(false);
    }

    const handleUploadArquivos = async (e) => {
        let target = e.target;
        let file = target.files ? target.files[0] : null;

        if (!getValues("Id")) {
            setSeverity("warning");
            setOpenError(true);
            setErrorMessage("Para adicionar documentos, é necessário salvar a solicitação com informações válidas.");

            setIsLoading(false);
            return;
        }

        if (file === null) {
            setOpenError(true);
            return setErrorMessage("Selecione um arquivo");
        }

        try {
            const formData = new FormData();

            let nomeArquivoSeparadoPorPonto = file.name.split('.');
            const extensaoArquivo = nomeArquivoSeparadoPorPonto.pop();
            const nomeArquivo = nomeArquivoSeparadoPorPonto.join('.');
            const size = file.size / 1024;

            formData.append("Arquivo", file);
            formData.append("CodigoSolicitacaoFiscalizacao", codigoSolicFiscalizacao);
            formData.append("CodigoProcesso", getValues("Id"));
            formData.append("NumeroProcesso", getValues("Protocolo"));

            const id = e.target.id;
            let codigos = id.split("-");

            if (codigos[5] != 0) {
                formData.append("CodigoDocumento", codigos[5]);
            }

            if (codigos[7] !== '*' && !codigos[7].includes(extensaoArquivo)) {
                setOpenError(true);
                setIsLoading(false);
                setErrorMessage(`Não é possível adicionar arquivos com a extensão "${extensaoArquivo}".`);
                return;
            }

            formData.append("CodigoConfiguracaoDoc", codigos[3]);
            formData.append("CodigoClassificacaoDoc", codigos[1]);
            formData.append("NomeArquivo", nomeArquivo);
            formData.append("ExtensaoArquivo", extensaoArquivo);
            formData.append("TamanhoKbArquivo", Math.trunc(size));

            setOpenUpload(true);
            setSeverity("info");
            setUploadMessage("Upload de arquivo iniciado")

            setTimeout(() => {
                setOpenUpload(false);
            }, [3000]);

            setIsLoading(true);
            let response = await servSolicitacaoFiscalizacaoDocs.AdicionaranexoSolicFiscalizacao(formData);

            const codigoSolicFiscalizacaoDoc = response.Content.Id;
            const codigoDocumento = response.Content.CodigoDocumento;

            setDocumentosObrigatorios((prev) =>
                prev.map((documento) => {
                    if (documento.Id == codigos[3]) {
                        return {
                            ...documento,
                            CodigoOcupanteDoc: codigoSolicFiscalizacaoDoc,
                            CodigoDocumento: codigoDocumento,
                            NomeArquivo: nomeArquivo + '.' + extensaoArquivo
                        };
                    }
                    return documento;
                })
            );

            e.target.value = '';

            setOpenUpload(true);
            setSeverity("success");
            setUploadMessage("Arquivo enviado com sucesso");
            setIsLoading(false);
            setTimeout(() => {
                setOpenUpload(false);
            }, [1000]);

        } catch (err) {
            setOpenError(true);
            setIsLoading(false);
            let statusErrorMessage = err.response.status + " - " + err.response.statusText;

            setErrorMessage(err.response.data.Message ? err.response.data.Message : statusErrorMessage);
        }
    }

    const handleDownloadArquivo = async (event) => {
        event.preventDefault();

        let codigoDocumento = Number(event.currentTarget.value);
        let codigoFiscalizacaoDoc = event.currentTarget.dataset.codigoIdDoc;

        if (!codigoFiscalizacaoDoc) {
            setOpenError(true);
            return setErrorMessage("Não há documento vinculado para download.");
        }

        try {
            setIsLoading(true);

            let response = await servSolicitacaoFiscalizacaoDocs.RealizarDownloadDocumento(codigoFiscalizacaoDoc);
            downloadConteudoBase64(response.Content.Nome, response.Content.Arquivo);

            setUploadMessage("Arquivo enviado com sucesso");
            setIsLoading(false);
        } catch (err) {
            setOpenError(true);
            setIsLoading(false);
            let statusErrorMessage = err?.response?.status + " - " + err?.response?.statusText;

            setErrorMessage(err?.response?.data?.Message ? err?.response?.data?.Message : statusErrorMessage);
        }
    }

    const handleInputDocumentos = () => {
        return documentosObrigatorios && documentosObrigatorios.map((doc) => {
            if (doc.Obrigatorio !== 2) {
                return ContainerUpload(doc);
            }
            return null;
        });
    }

    const handleRemoverArquivo = async (event) => {
        event.preventDefault();

        let codigoFiscalizacaoDoc = event.currentTarget.dataset.codigoIdDoc;

        if (!codigoFiscalizacaoDoc) {
            setOpenError(true);
            return setErrorMessage("Não há documento vinculado para remoção.");
        }

        try {
            setIsLoading(true);

            await servSolicitacaoFiscalizacaoDocs.RemoverAnexoFiscalizacao(codigoFiscalizacaoDoc);

            setDocumentosObrigatorios((prev) =>
                prev.map((doc) => {
                    if (doc.CodigoOcupanteDoc === codigoFiscalizacaoDoc) {
                        return {
                            ...doc,
                            CodigoDocumento: null,
                            CodigoOcupanteDoc: null,
                            NomeArquivo: null
                        };
                    }
                    return doc;
                }));

            setOpenUpload(true);
            setSeverity("success");
            setUploadMessage("Arquivo excluído com sucesso");
            setIsLoading(false);
        }
        catch (err) {
            setOpenUpload(true);
            setIsLoading(false);
            setSeverity("error");
            let statusErrorMessage = err?.response?.status + " - " + err?.response?.statusText;

            setUploadMessage(err?.response?.data?.Message ? err?.response?.data?.Message : statusErrorMessage);
        }
    }

    const ContainerUpload = (doc) => {
        return (
            <div
                className={styles['upload-field']}
                key={`classifDoc-${doc.CodigoClassificacaoDoc}-configdoc-${doc.Id}-codigodoc-${doc.CodigoDocumento ?? 0}`}
            >
                <UploadInput
                    handleUploadArquivos={handleUploadArquivos}
                    handleDownloadArquivo={handleDownloadArquivo}
                    handleRemoverArquivo={handleRemoverArquivo}
                    id={`classifDoc-${doc.CodigoClassificacaoDoc}-configdoc-${doc.Id}-codigodoc-${doc.CodigoDocumento ?? 0}-extensoes-${doc.ExtensoesValidas}`}
                    label={doc.Descricao}
                    aprovado={doc.Aprovado}
                    situacaoSolic={situacaoSolic}
                    register={register}
                    registerName={doc.Descricao.replace(/\s/g, '-')}
                    obrigatorio={doc.Obrigatorio}
                    codigoDocumento={doc.CodigoDocumento || 0}
                    codigoIdDoc={doc.CodigoOcupanteDoc || 0}
                    disabled={!editavel}
                    nomeArquivo={doc.NomeArquivo}
                    extensoesValidas={doc.ExtensoesValidas}
                />
            </div>
        );
    };

    return (
        <div style={{ paddingRight: "20px" }}>
            <div className={styles['cadastro-documentos']}>
                {handleInputDocumentos()}
            </div>
            <Snackbar open={openUpload} onClose={handleCloseInfo} anchorOrigin={{ vertical: 'top', horizontal: 'right' }} autoHideDuration={1000}>
                <Alert onClose={handleCloseInfo} severity={severity} sx={{ width: '100%' }}>
                    {uploadMessage}
                </Alert>
            </Snackbar>
        </div>
    )
}

export { Documentos }